import React from "react";
import styled from "@emotion/styled";

import {display, p, pointer} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    className?: string;
    onClick: () => void;
}

export const InlineButton: React.FC<IProps> = (props) => {
    return (
        <InlineButtonBase css={props.className} onClick={props.onClick}>
            <Text variant="info_txt_1">
                <Highlight>{props.children}</Highlight>
            </Text>
        </InlineButtonBase>
    );
};

const InlineButtonBase = styled.button`
    ${display("inline-block")};
    background-color: transparent;
    border: none;
    ${pointer};
    ${p(0)};
`;
import React from "react";
import styled from "@emotion/styled";

import {display, p, pointer} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    className?: string;
    onClick: () => void;
}

export const InlineButton: React.FC<IProps> = (props) => {
    return (
        <InlineButtonBase css={props.className} onClick={props.onClick}>
            <Text variant="info_txt_1">
                <Highlight>{props.children}</Highlight>
            </Text>
        </InlineButtonBase>
    );
};

const InlineButtonBase = styled.button`
    ${display("inline-block")};
    background-color: transparent;
    border: none;
    ${pointer};
    ${p(0)};
`;
